import { endpoint } from "../../../server/router/web/endpoint";
import { QuestionResponse } from "../../../server/types/response/question";

export class Request {
	/**
	 * 回答情報の送信
	 * @param {string} url リクエスト先
	 * @returns {Promise<QuestionResponse>}
	 */
	public static async postAnswer(): Promise<QuestionResponse> {
		const ins = new this();
		const formData = new FormData($("form").get(0) as HTMLFormElement);
		return ins.postFormData<QuestionResponse>(`${endpoint.question}/next`, formData);
	}
	public static async previousPage(): Promise<QuestionResponse> {
		const ins = new this();
		const formData = new FormData();
		formData.append("_csrf", $("[name='_csrf']").val().toString());
		return ins.postFormData<QuestionResponse>(`${endpoint.question}/previous`, formData);
	}
	/**
	 * json形式でpost
	 * @param {string} url リクエスト先
	 * @param { [key: string]: any } data リクエストデータ
	 * @returns {Promise<Response>}
	 */
	public static async postJson<Response = any>(url: string, data: { [key: string]: any }): Promise<Response> {
		const ins = new this();
		return ins.postJson(url, data);
	}
	/**
	 * formdataでデータのpost
	 * @param {string} url
	 * @param {FormData} formData
	 * @returns {Promise<Response>} 次の設問情報 or エラー情報
	 */
	public static async postFormData<Response>(url: string, formData: FormData): Promise<Response> {
		const ins = new this();
		return ins.postFormData<Response>(url, formData);
	}
	/**
	 * getでのrequest
	 * @param {string} url
	 * @param {{ [key: string]: any }} param
	 * @returns {Promise<Response>}
	 */
	protected static async get<Response = any>(url: string, param: { [key: string]: any }): Promise<Response> {
		const ins = new this();
		return ins.get(url, param);
	}
	/**
	 * formdataでデータのpost
	 * @param {string} url
	 * @param {FormData} formData
	 * @returns {Promise<Response>} 次の設問情報 or エラー情報
	 */
	protected async postFormData<Response>(url: string, formData: FormData): Promise<Response> {
		return new Promise<Response>((resolve, reject) => {
			$.ajax({
				url,
				async: true,
				method: "post",
				dataType: "json",
				data: formData,
				processData: false,
				contentType: false,
			}).then(
				(data) => {
					resolve(data);
				},
				(err) => {
					reject(err);
				}
			);
		});
	}
	/**
	 * json形式でpost
	 * @param {string} url リクエスト先
	 * @param { [key: string]: any } data リクエストデータ
	 * @returns {Promise<Response>}
	 */
	protected async postJson<Response = any>(url: string, data: { [key: string]: any }): Promise<Response> {
		const requestData = { ...data };
		requestData["_csrf"] = $("input[name='_csrf']").val() as string;
		return new Promise((resolve, reject) => {
			$.post(
				url,
				requestData,
				(response) => {
					resolve(response);
				},
				"json"
			).fail((err) => {
				reject(err);
			});
		});
	}
	/**
	 * csrfの取得
	 * @returns {string | undefined}
	 */
	protected getCSRF(): string | undefined {
		const v = $("input[name='_csrf']").val();
		if (typeof v === "string") return v;
		return undefined;
	}
	/**
	 * jsonからqueryStringを作成
	 * @param { [key: string]: any } param
	 * @returns {string}
	 */
	public makeQueryString(param: { [key: string]: any }): string {
		const queries = [];
		for (const key in param) {
			const value = param[key];
			if (value instanceof Array) {
				for (const v of value) {
					queries.push(`${key}[]=${v}`);
				}
			} else {
				queries.push(`${key}=${value}`);
			}
		}
		return queries.join("&");
	}
	/**
	 * getでのrequest
	 * @param {string} url
	 * @param {{ [key: string]: any }} param
	 * @returns {Promise<T>}
	 */
	protected async get<T = any>(url: string, param: { [key: string]: any }): Promise<T> {
		return new Promise<T>((resolve, reject) => {
			$.get(url + "?" + this.makeQueryString(param), (p) => {
				resolve(p as T);
			}).fail((err) => {
				reject(err);
			});
		});
	}
}
